// Shared data windows for all v4 screens (keeps every screen consistent).
import { getDataset, sumRange, seriesRange } from 'app/demo/dataset';

export const TIER = {
  prospecting: { label: 'Prospecting', color: '#5A54F3' },
  retargeting: { label: 'Retargeting', color: '#38bdf8' },
  retention: { label: 'Retention', color: '#8AE8BD' },
  brand: { label: 'Brand', color: '#ec4899' },
};

// monthly goals (mirror demoConfig goals; cur best-in-class beats them)
export const GOALS = { revenue: 1150000, mer: 3.5, roas: 3.5, aov: 95 };

export function v4data(win = 30) {
  const ds = getDataset();
  const dates = ds.dates;
  const last = dates.length - 1;
  const from = dates[Math.max(0, last - (win - 1))];
  const to = dates[last];
  const pFrom = dates[Math.max(0, last - (win * 2 - 1))];
  const pTo = dates[Math.max(0, last - win)];
  const cur = sumRange(ds.accountDaily, from, to);
  const prev = sumRange(ds.accountDaily, pFrom, pTo);
  const daily = seriesRange(ds.accountDaily, from, to);
  return {
    ds, dates, last, win, from, to, pFrom, pTo, cur, prev, daily,
    dayLabels: daily.map((d) => { const [, m, dd] = d.day.split('-'); return `${+dd}/${+m}`; }),
    campSum: (c, f, t) => sumRange(c.daily, f || from, t || to),
    campSeries: (c, f, t) => seriesRange(c.daily, f || from, t || to),
  };
}

export { getDataset, sumRange, seriesRange };
